import { render } from "./addTagIcon.vue?vue&type=template&id=1f54cac5"
import script from "./addTagIcon.vue?vue&type=script&lang=js"
export * from "./addTagIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__